module.exports = __webpack_public_path__ + "img/comment.bd5b9242.svg";